import React from 'react';

const dateStr = (date) => date.toString().padStart(2, '0');
const Time = () => {
  const date = new Date();
  const hh = dateStr(date.getHours());
  const mm = dateStr(date.getMinutes());
  return (
    <>
      {hh}:{mm}
    </>
  );
};

export default Time;
